import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { IconChoiceComponent } from './icon-choice.component';

export const ROUTES/*: Routes*/ = [
    { path: 'icon-choice', component: IconChoiceComponent },
];


@NgModule({
    imports: [
        RouterModule.forChild(ROUTES),
    ],
    declarations: [
        IconChoiceComponent,
    ],
    exports: [
        IconChoiceComponent,
    ],
})
export class IconChoiceModule {}
